import { relationships } from "@rocicorp/zero";
import { crew } from "./crew";
import { organization } from "./organization";
import { plan } from "./plan";
import { ticketAssignment } from "./ticket-assignment";
import { userAssignment } from "./user-assignment";
import { vehicleAssignment } from "./vehicle-assignment";

export const crewRelationships = relationships(crew, ({ many, one }) => ({
	organization: one({
		sourceField: ["orgId"],
		destField: ["id"],
		destSchema: organization,
	}),
	plan: one({
		sourceField: ["planId"],
		destField: ["id"],
		destSchema: plan,
	}),
	ticketAssignments: many({
		sourceField: ["id"],
		destField: ["crewId"],
		destSchema: ticketAssignment,
	}),
	userAssignments: many({
		sourceField: ["id"],
		destField: ["crewId"],
		destSchema: userAssignment,
	}),
	vehicleAssignment: many({
		sourceField: ["id"],
		destField: ["crewId"],
		destSchema: vehicleAssignment,
	}),
}));
